module.exports = __webpack_public_path__ + "static/img/JP@2x.e324c0cc.jpg";